<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM10.75 9.99997H12.25C12.6642 9.99997 13 10.3358 13 10.75V16H13.75C14.1642 16 14.5 16.3358 14.5 16.75C14.5 17.1642 14.1642 17.5 13.75 17.5H10.7478C10.3336 17.5 9.9978 17.1642 9.9978 16.75C9.9978 16.3358 10.3336 16 10.7478 16H11.5V11.5H10.75C10.3358 11.5 10 11.1642 10 10.75C10 10.3358 10.3358 9.99997 10.75 9.99997Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
